import { useEffect } from "react";

const SITE_NAME = "Vaseegrah Veda";
const SITE_URL = "https://vaseegrah.in";
const DEFAULT_TITLE =
  "Vijaya Mahadevan | Founder of Vaseegrah Veda | Herbal Wellness in Thanjavur";
const DEFAULT_DESCRIPTION =
  "Discover Vijaya Mahadevan's story and Vaseegrah Veda, a Thanjavur-based herbal brand offering hair care, skin care, bath powders, custom blends, and women-led training.";
const DEFAULT_IMAGE = `${SITE_URL}/assets/vijaya.png`;
const ROBOTS =
  "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
const TWITTER_CARD = "summary_large_image";
const TWITTER_HANDLE = "@vaseegrahveda";
const OG_LOCALE = "en_IN";
const OG_IMAGE_WIDTH = "1200";
const OG_IMAGE_HEIGHT = "630";

function upsertMeta(attrName, attrValue, content) {
  if (!content) return;

  let tag = document.head.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attrName, attrValue);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;

  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }

  tag.setAttribute("href", href);
}

export default function Seo({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  canonical = SITE_URL,
  image = DEFAULT_IMAGE,
  type = "website",
}) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    document.documentElement.lang = "en-IN";

    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", ROBOTS);
    upsertMeta("name", "twitter:card", TWITTER_CARD);
    upsertMeta("name", "twitter:site", TWITTER_HANDLE);
    upsertMeta("name", "twitter:creator", TWITTER_HANDLE);
    upsertMeta("name", "twitter:title", title || DEFAULT_TITLE);
    upsertMeta("name", "twitter:description", description || DEFAULT_DESCRIPTION);
    upsertMeta("name", "twitter:image", image || DEFAULT_IMAGE);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:locale", OG_LOCALE);
    upsertMeta("property", "og:title", title || DEFAULT_TITLE);
    upsertMeta("property", "og:description", description || DEFAULT_DESCRIPTION);
    upsertMeta("property", "og:url", canonical || SITE_URL);
    upsertMeta("property", "og:image", image || DEFAULT_IMAGE);
    upsertMeta("property", "og:image:alt", title || DEFAULT_TITLE);
    upsertMeta("property", "og:image:width", OG_IMAGE_WIDTH);
    upsertMeta("property", "og:image:height", OG_IMAGE_HEIGHT);

    upsertLink("canonical", canonical || SITE_URL);
  }, [title, description, canonical, image, type]);

  return null;
}
